import React from 'react';

import { RemindersTableWithAddOption } from '../../components/RemindersTableWithAddOption';

import { useGetProjectReminders } from './useGetProjectReminders';

export const ProjectRemindersTable: React.FC<{ projectId: string }> = ({ projectId }) => {
  const { data } = useGetProjectReminders(projectId);

  return <RemindersTableWithAddOption objectId={projectId} objectClass="PROJECT" data={data} />;
};
